// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2548":"3fed282c","3366":"3fed282c","5455":"6a40be63"}[chunkId] + ".chunk.css";
};